import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/vision_test_plans')({
  staticData: { breadcrumb: 'Vision Test Plans' },
  component: () => <Outlet />,
});
